<template>
    <div style="background-color: white;padding: 25px">
        <h2 class="text-center p-3">ใบจองสินค้า</h2>
        <div class="row">
            <div class="col-sm-6">
                <!-- Customer select -->
                <div class="form-group row">
                    <label
                        class="col-sm-4 col-form-label text-capitalize text-right"
                    >รหัสลูกค้า</label
                    >
                    <div class="col-sm-8">
                        <!-- <b-form-select v-model="form.customer" -->
                        <!-- :options="customers"> -->
                        <!-- </b-form-select> -->
                        <input
                            class="form-control"
                            v-model="form.customer.customer_id"
                            disabled
                        />
                    </div>
                </div>

                <!-- Customer data -->
                <template v-if="form.customer">
                    <div class="form-group row">
                        <label
                            class="col-sm-4 col-form-label text-capitalize text-right"
                        >ลูกค้า</label
                        >
                        <div class="col-sm-8 col-form-label">
                            <p>
                                {{ form.customer.first_name }}
                                {{ form.customer.last_name }}
                            </p>
                            <p>{{ form.customer.address }}</p>
                            <p>โทร {{ form.customer.phone }}</p>
                        </div>
                    </div>
                </template>

                <p>พนักงานขาย 16 ธนากรณ์ 094-857-6555</p>
            </div>

            <div class="col-sm-6">
                <!-- order id -->
                <div class="form-group row">
                    <label
                        class="col-sm-4 col-form-label text-capitalize text-right"
                    >เลขที่ใบจอง</label
                    >
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            v-model="form.order_id"
                            disabled
                        />
                    </div>
                </div>
                <!-- Transport select -->
                <div class="form-group row">
                    <label
                        class="col-sm-4 col-form-label text-capitalize text-right"
                    >การขนส่ง</label
                    >
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            v-model="form.transport_type.name"
                            disabled
                        />
                    </div>
                </div>

                <!-- Vendor select -->
                <div class="form-group row">
                    <label
                        class="col-sm-4 col-form-label text-capitalize text-right"
                    >ผู้ให้บริการ</label
                    >
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            v-model="form.vendor.vendor_id"
                            disabled
                        />
                    </div>
                </div>
            </div>
        </div>
        <table class="table text-center">
            <thead>
            <tr>
                <th scope="col">รายการ</th>
                <th scope="col">จำนวน</th>
                <th scope="col">ราคา/หน่วย</th>
                <th scope="col">ราคา/รวม</th>
                <th scope="col">โปรโมชั่น</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(detail, index) in form.details">
                <tr>
                    <td>{{ detail.product.name }}</td>
                    <td>{{ detail.quantity }}</td>
                    <td>{{ detail.price }}</td>
                    <td>{{ detail.quantity * detail.price }}</td>
                    <td>{{ detail.promotion }}</td>
                </tr>
            </template>
            </tbody>
        </table>
        <span style="padding-left: 25px">รวมทั้งหมด :{{ totalPrice }} บาท</span>
        <br/><br/>
        <div class="text-right">
            <button class="btn btn-success mb-3" @click="goToInvoiceForm">
                <icon name="check"></icon>
                สร้างใบแจ้งหนี้ (invoice)
            </button>
        </div>
        <!-- <pre class="alert alert-primary">{{ form }}</pre> -->
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "order-show",
    props: {
        id: {default: null}
    },
    created() {
        //console.log(this.id);
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Order.orderForm;
            },
            customers: state => {
                return [
                    {
                        value: null,
                        text: "เลือกลูกค้า"
                    },
                    ...state.Customer.data.map(customer => ({
                        value: customer,
                        text: customer.name
                    }))
                ];
            },
            vendors: state => {
                return [
                    {
                        value: null,
                        text: "เลือกผู้ให้บริการ"
                    },
                    ...state.Vendor.vendorList.map(vendor => ({
                        value: vendor,
                        text: vendor.name
                    }))
                ];
            },
            transportTypes: state => {
                return [
                    {
                        value: null,
                        text: "เลือกประเภทการขนส่ง"
                    },
                    ...state.TransportType.transportTypeList.map(
                        transportType => ({
                            value: transportType,
                            text: transportType.name
                        })
                    )
                ];
            }
        }),

        totalPrice() {
            return this.form.details.reduce((carry, detail) => {
                return carry + detail.quantity * detail.price;
            }, 0);
        }
    },
    methods: {
        goToInvoiceForm() {
            this.$store.dispatch("Order/createInvoiceFromOrder").then(() => {
                this.$store.dispatch("Invoice/generateOrder");
                this.$router.push({
                    name: "invoice-form",
                    params: {
                        id: this.form.id
                    }
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
thead {
    background-color: gray;
}

tbody {
    background-color: white;
}
</style>
